<form [formGroup]="loginForm" name="loginForm" novalidate>
    <mat-form-field [floatLabel]="floatLabelControl">
        <mat-label>{{ 'authentication.login' | translate }}</mat-label>
        <input [attr.disabled]="renewPassword && settings.activeChangePasswordStrategy"
               data-e2e="input-login"
               formControlName="login"
               matInput
               required
        />

        <mat-error *ngIf="loginFormErrors.login.required">
            <span>{{ "authentication.login.required" | translate }}</span>
        </mat-error>

        <mat-error *ngIf="loginFormErrors.login.invalid">
            <span>{{ "authentication.login.invalid" | translate }}</span>
        </mat-error>

        <mat-error *ngIf="loginFormErrors.login.email">
            <span>{{ "authentication.login_email" | translate }}</span>
        </mat-error>
    </mat-form-field>

    <mat-form-field [floatLabel]="floatLabelControl"
                    *ngIf="!renewPassword">
        <mat-label>{{ 'authentication.password' | translate }}</mat-label>
        <input
            [attr.disabled]="(renewPassword && settings.activeChangePasswordStrategy) || loginFormErrors.emailValidation.invalid"
            [type]="hide ? 'password' : 'text'"
            data-e2e="input-password"
            formControlName="password"
            matInput
            required
        />
        <mat-icon
            (click)="hide = !hide"
            class="visibility-icon"
            matSuffix
            svgIcon="{{ hide ? 'visibility' : 'visibility_off' }}"
        >
        </mat-icon>

        <mat-error *ngIf="loginFormErrors.password.required">
            <span>{{ "authentication.password.required" | translate }}</span>
        </mat-error>

        <mat-error *ngIf="loginFormErrors.password.invalid">
            <span>{{ "authentication.password.invalid" | translate }}</span>
        </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="renewPassword && settings.activeChangePasswordStrategy"
                    [floatLabel]="floatLabelControl">
        <mat-label>{{ 'authentication.new.password' | translate }}</mat-label>
        <input
            [type]="hideNewPassword ? 'password' : 'text'"
            autocomplete="off"
            formControlName="newPassword"
            matInput
            name="changePassword"

            required
        />
        <mat-icon
            (click)="hideNewPassword = !hideNewPassword"
            matSuffix
            svgIcon="{{ hideNewPassword ? 'visibility' : 'visibility_off' }}"
        >
        </mat-icon>

        <mat-error *ngIf="loginFormErrors.newPassword.required">
            <span>{{ "authentication.password.required" | translate }}</span>
        </mat-error>

        <mat-error *ngIf="loginFormErrors.newPassword.samePasswordAsOrigine">
            <span>{{ "authentication.password.must.be.change" | translate }}</span>
        </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="renewPassword && settings.activeChangePasswordStrategy"
                    [floatLabel]="floatLabelControl">
        <mat-label>{{ 'authentication.new.password' | translate }}</mat-label>
        <input
            [type]="hideConfirmPassword ? 'password' : 'text'"
            autocomplete="off"
            formControlName="confirmPassword"
            matInput
            name="confirmPassword"

            required
        />
        <mat-icon
            (click)="hideConfirmPassword = !hideConfirmPassword"
            matSuffix
            svgIcon="{{
                  hideConfirmPassword ? 'visibility' : 'visibility_off'
                }}"
        >
        </mat-icon>

        <mat-error *ngIf="loginFormErrors.confirmPassword.notMatch">
            <span>{{ "account-management.password-confirm.not-identical" | translate }}</span>
        </mat-error>
    </mat-form-field>

    <div
        *ngIf="!settings.enableSSO && !renewPassword"
        class="remember-forgot-password"
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutAlign="space-between center"
    >
        <a [routerLink]="'/forgot-password'" class="forgot-password">
            {{ "authentication.forgotten-password" | translate }}
        </a>
    </div>

    <app-register-link></app-register-link>

    <button
        (click)="onLoginClick()"
        *ngIf="!loginFormErrors.emailValidation.invalid"
        [disabled]="loginForm.invalid"
        class="submit-button"
        color="accent"
        data-e2e="button-submit"
        mat-raised-button
    >
        {{ "authentication.btn-login" | translate }}
    </button>
    <!-- if auto redirection doesnt work -->
    <mat-error *ngIf="showMessageForReloadPage">
                                <span class="show-message-reload-page">
                                    {{ "generic.message_reload_page" | translate }}</span>
    </mat-error>
    <!--if mail was not validated error msg and button to send again email link -->
    <mat-error *ngIf="loginFormErrors.emailValidation.invalid">
        <span>{{ "generic.email.validation.invalid" | translate }}</span>
    </mat-error>
    <!--no licence-->
    <mat-error *ngIf="loginFormErrors.licenceValidation.invalid">
        <span>{{ "generic.validation.licence.invalid" | translate }}</span>
    </mat-error>
    <mat-error *ngIf="newLinkSendError">
        <span>{{ "generic.email.not.send" | translate }}</span>
    </mat-error>

    <p *ngIf="newLinkSendSuccess">
        {{ "generic.email.send" | translate }}
    </p>

    <p *ngIf="!!licenceLink"
       class="login__licence-link">{{ 'account-management.ask_licence_part1' | translate }}
        <a
            [href]="licenceLink"
            ariaLabelTranslate="{{ 'account-management.ask_licence_part2' | translate }}"
            class="link"
            target="_blank"
        >
            {{ "account-management.ask_licence_part2" | translate }}</a>
    </p>

    <button
        (click)="onSendLinkToValidateEmailClick()"
        *ngIf="loginFormErrors.emailValidation.invalid"
        color="accent"
        mat-raised-button
    >
        {{ "generic.email.validation.invalid.send.new.link" | translate }}
    </button>
</form>